import { getSessionId } from '../../../../utils/env/getSessionId';
import { IErrorParams } from '../ErrorLogger.types';
import { isMediaManagerSDKNetworkError, reasonToString } from '../utils';
import { captureException, setExtras, setTags, setUser } from '@sentry/browser';
import { getLocale } from '../../../../utils/env/getLocale';
import { removeUndefinedValues } from '../../../../utils/object';

export function updateSentryGlobalInfo({ name, userId, metaSiteId, mmgrSettings }) {
  setUser({ username: name, metaSiteId, id: userId });
  setTags({ locale: getLocale(), msid: metaSiteId });
  setExtras({ sessionId: getSessionId(), mmgrSettings });
}

export function sentryConsumer({ errorDefinition, reason, p1, p2, p3, p4 }: IErrorParams) {
  const normalizedReason = isMediaManagerSDKNetworkError(reason) ? reasonToString(reason) : reason;

  setTags({ errorId: String(errorDefinition.id), errorName: errorDefinition.name });
  setExtras(removeUndefinedValues({ reason, p1, p2, p3, p4 }));

  captureException(normalizedReason);
}
